
/**
 * Shouldn't be this complicated to convert b64 to binary.
 */
const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
  const byteCharacters = Buffer.from(b64Data, 'base64');
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice[i];
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, {type: contentType});
}

export { b64toBlob }
